import VueCompositionApi, { ref } from "@vue/composition-api";
import Vue from "vue";

Vue.use(VueCompositionApi);

let title = ref("");
const icon = ref("");

export function useTitle() {
  const setTitle = (value) => {
    title.value = value;
    document.title = value;
  };
  const setIcon = function (value) {
    icon.value = value;
  };
  return {
    title,
    setTitle,
    icon,
    setIcon,
  };
}
